<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Edycja komponentu <strong>{{ component.component.name }} - {{ component.calculationProductName }}</strong>
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row>
                    <template v-for="(property, index) in component.calculationProductComponentProperties">
                        <v-col
                            v-if="!isPaperProperty(property.productProductionPropertyId)"
                            :key="property.id"
                            cols="12"
                            lg="6"
                        >
                            <v-text-field
                                v-model="property.value"
                                v-mask="'######'"
                                :label="property.productProductionProperty.verboseName | capitalize"
                                outlined
                                dense
                                :error="propertyErrors(index)"
                                hide-details
                            />
                        </v-col>
                    </template>
                    <v-col cols="12" lg="6">
                        <v-text-field
                            v-model="component.parts"
                            v-mask="'##'"
                            label="Ilość użytków"
                            outlined
                            dense
                            :error="partsErrors()"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

export default {
    name: 'EditComponentDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        componentData: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            component: {
                component: {
                    name: null
                }
            }
        }
    },
    validations() {
        const rules = {
            component: {
                calculationProductComponentProperties: {
                    $each: {
                        value: {
                            required
                        }
                    }
                },
                parts: { required }
            }
        }

        return rules
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.component = JSON.parse(JSON.stringify(this.componentData))
            } else {
                setTimeout(() => {
                    this.resetComponentData()
                    this.$v.$reset()
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
            } else {
                this.$emit('on-save', this.component)
            }
        },
        onClose() {
            if (!this.actionLoading) {
                this.$emit('on-close')
            }
        },
        isPaperProperty(productProductionPropertyId) {
            return productProductionPropertyId == 8
        },
        resetComponentData() {
            this.component = {
                component: {
                    name: null
                }
            }
        },
        propertyErrors(index) {
            if (!this.$v.component.calculationProductComponentProperties.$each[index].value.$dirty) return

            return !this.$v.component.calculationProductComponentProperties.$each[index].value.required
        },
        partsErrors() {
            if (!this.$v.component.parts.$dirty) return

            return !this.$v.component.parts.required
        }
    }
}
</script>
